import React from 'react';
import { Container, Col, Row, Button } from 'reactstrap';
import TextField from "material-ui/TextField";
import MenuItem from "material-ui/MenuItem";
import SelectField from "material-ui/SelectField";
import Dialog from 'material-ui/Dialog';
import InputMask from 'react-input-mask';
import '../../../assets/css/required.css'
import queryString from 'query-string';
import axios from 'axios';
import urlBase from '../../../url-base';
import Checkbox from 'material-ui/Checkbox';

//import CKEditor from 'ckeditor4-react';

class BrokerRegistration extends React.Component {
  constructor(props) {
    super(props);

    this.state = {


      id: '',
      name: '',
      responsible: '',
      modalErrors: false
    }

    //this.requiredFields = ['name', 'codes4', 'description', 'status'];
    this.requiredFields = ['name'];

    // Erros
    this.errorField = {
      grupos: []
    };

  }

  componentDidMount() {
    var params = queryString.parse(window.location.search);
    if(params) {
      if(params.edit) {
        axios.get(urlBase.loopBack + 'Broker/'+params.edit).then((data) => {

          const broker = data.data;
          
          this.setState({
            id: broker.id,
            name: broker.name,
            responsible: broker.responsible
          });

          if(!broker.priceGroups.length){
            this.handlerAppendPriceGroup();
          } else {
            broker.priceGroups.map((price) => {
              this.getCity(price.uf, (data) => {
                price.cityList = data;
                this.handlerAppendPriceGroup(price);
              });
            })
          }
        
          if(!broker.carenciaGroups.length){
            this.handlerAppendCarenciaGroup();
          } else {
            broker.carenciaGroups.map((carencia) => {
              this.handlerAppendCarenciaGroup({
                carenciaName: carencia.name,
                carenciaCard: carencia.card,
                carenciaBoleto: carencia.boleto
              });
            })
          }

        });
      } else {
        this.handlerAppendCarenciaGroup();
        this.handlerAppendPriceGroup();
      }     
    } else {
      this.handlerAppendCarenciaGroup();
      this.handlerAppendPriceGroup();
    }
    axios.get(urlBase.loopBack + 'APIS4s/UFs').then((data)=>{
      this.setState({stateList: data.data});
    })
    .catch(function (erro) {
    //Tratar esse erro
      console.log(erro);
    });    
  }

  getCity(uf=null, fnCalback=null) {
    uf = parseInt(uf);

    // Pega a lista de cidades
    const url = urlBase.loopBack+'APIS4s/Municipios';
    let	dataPost = {
      idUF: uf
    };
    axios.post(url, dataPost)
    .then((result) => {
      if (fnCalback != null) {
        fnCalback(result.data);
      }
    })
    .catch(function (erro) {
      alert(erro);
    });
  }


  handleChange(e, _name, event, index, _value){
    let name = _name || e.target.name;

    if ([
        "uf", "city", 'price', 'promotionPrice', 'categoryPrice', 
        'quantity', 'startDate', 'endDate'
      ].includes(name) ) {
      let inputs = [...this.state.grupos] ; 

      let chave = e.chave || e.target.dataset.id;
      let value = _value ||  e.target.value;

      let index = -1;
      inputs.map((value, i) => {
        if(value.chave == chave ) index = i;
      })
      
      inputs[index][name] = value;

      if (name == 'uf') {
        this.getCity(value, (data) => {
          inputs[index].cityList = data;
          this.setState({ inputs });
        });
      } else {
        this.setState({ inputs });
      }
    } else {
      if ([ 'carenciaName', 'carenciaCard', 'carenciaBoleto' ].includes(name) ) {
      let inputs = [...this.state.carencias] ; 

      let chave = e.chave || e.target.dataset.id;
      let value = _value ||  e.target.value;

      let index = -1;
      inputs.map((value, i) => {
        if(value.chave == chave ) index = i;
      })
      
      inputs[index][name] = value;

      this.setState({ inputs });
    } else {  
        try{
          _name = e.target.name;
          _value = e.target.value;
        } catch(error) {
          console.log(error);
          _name = name;
        }

        this.setState({ [_name]: _value });
      }
  
    }
  }

  handleErrorClose() {
    this.setState({modalErrors: false});
  }

  handleErrorOpen() {
    this.setState({modalErrors: true});
    return false;
  }

  handlerAppendPriceGroup( data  = null) {
    var chave = Math.floor((Math.random() * 9999) +1);
    var newInput = {...this.state.defaultPriceGroup};
    newInput.chave = chave;
    newInput.stateList = this.state.stateList;

    if(data) {
      newInput = Object.assign(newInput, data);
    }

    // this.errorField.grupos.push(newInput);
    this.setState(prevState => ({ grupos: prevState.grupos.concat([newInput]) }));
  }  

  handlerAppendCarenciaGroup( data  = null) {
    var chave = Math.floor((Math.random() * 999999) +1);
    var newInput = {...this.state.defaultCarenciaGroup};
    newInput.chave = chave;

    if(data) {
      newInput = Object.assign(newInput, data);
    }

    // this.errorField.carencias.push(newInput);
    this.setState(prevState => ({ carencias: prevState.carencias.concat([newInput]) }));
  }  

  handleDeletePriceGroup (obj) {
    let index = this.state.grupos.indexOf(obj);
    this.state.grupos.splice(index, 1);

    this.setState(() => ({ grupos:  this.state.grupos }));
  }

  handleDeleteCarenciaGroup (obj) {
    let index = this.state.carencias.indexOf(obj);
    this.state.carencias.splice(index, 1);

    this.setState(() => ({ carencias:  this.state.carencias }));
  }

  hanlderSubmit() {
    let dataPost = {
      "name": this.state.name,
     // "description": this.state.description,
      "status": this.state.status,
      "codeS4": this.state.codeS4,
      "value": this.state.value,
      "usersTable": this.state.usersTable,
      "type": this.state.type,
      "familyTable" : {
            "value2": this.state.value2,
            "value3": this.state.value3,
            "value4": this.state.value4                        
      },
      
    //  "badge": this.state.badge,
    //  "priceGroups": [],
   //   "carenciaGroups": []
    };

    this.state.grupos.map((value) => {
      if(value.price && value.uf) {
        let price = {
            uf: value.uf,
            city: value.city,
            startDate: value.startDate,
            endDate: value.endDate,
            price: value.price,
            promotionPrice: value.promotionPrice,
            quantity: value.quantity,
            categoryPrice: value.categoryPrice,
        }
        dataPost.priceGroups.push(price)
      }
    });

    this.state.carencias.map((value) => {
      if(value.carenciaName && (value.carenciaBoleto || value.carenciaCard)) {
        let item = {
            name: value.carenciaName,
            card: value.carenciaCard,
            boleto: value.carenciaBoleto
        }
        dataPost.carenciaGroups.push(item);
      }
    });

    let requestAxios;
    let message = `Sucesso ao cadastrar o Plano`;
    if(this.state.id) {
      dataPost.id = this.state.id;
      message = `Sucesso ao editar o Plano`;
     // requestAxios = axios.put(urlBase.loopBack + 'PlansPrices', dataPost)
     requestAxios = axios.put(urlBase.loopBack + 'Plans', dataPost)
    } else {
      //requestAxios =  axios.post(urlBase.loopBack + 'PlansPrices', dataPost);
      requestAxios =  axios.post(urlBase.loopBack + 'Plans', dataPost);
    }

    requestAxios.then(() => {
      alert(message);
      setTimeout(() => {
        window.location.href= urlBase.client +'panel/planlist';
      }, 1000);
    }).catch((err) => {
      console.log(err);
      this.setState({modalErrors: true})
    });
  }
  confirmCheck(e, isInputChecked) {
    let state = this.state;
    state.usersTable = isInputChecked;
    this.setState(state);


}
  render() {
    return (
      <div>

        <p id="div_top" style={{marginBottom: 35}} className="title_form">
          MANUTENÇÃO DE PLANOS
        </p>

        <Container className="form_container_panel2">
          <Container className="form_container_internal_panel">

            <p style={{marginBottom: 0}} className="form_p_title">DADOS DO PLANO</p>
            <p className="form_p_title2">(Informações básicas do plano)</p>

            <Row>
              <Col id="i_name" sm="12"  style={{height:80}}>
                <TextField
                  floatingLabelText="NOME DO PLANO *"
                  name="name"
                  fullWidth={true}
                  errorText={this.errorField.name}
                  value={this.state.name}
                  onChange={this.handleChange.bind(this)}
                />
              </Col>

               {/* 
               <Col xs="12" sm="12" md="12" lg="12" style={{marginBottom:40}}>
               
               <CKEditor
                    data={this.state.description}
                    onChange={evt => this.setState({description: evt.editor.getData()})}/>
              </Col>
              */} 
            </Row>

            <Row>
              <Col id="i_codeS4"  style={{height:80}}>
                <TextField
                  floatingLabelText="CÓDIGO S4 *"
                  name="codeS4"
                  errorText={this.errorField.codeS4}
                  value={this.state.codeS4}
                  onChange={this.handleChange.bind(this)}
                />
              </Col>
              <Col id="i_value"  style={{height:80}}>
              <TextField
                  floatingLabelText="Valor"
                  fullWidth={true}
                  name="value"
                  >
                    <InputMask 
                      mask="99,99"
                      maskChar=" "
                      errorText={this.errorField.value}
                      value={this.state.value}
                      onChange={this.handleChange.bind(this)}     
                      name="value"
               
                    />
                  </TextField>
              </Col>    
              <Col id="i_tipo"  style={{height:80}}>
                <SelectField
                  floatingLabelText="TIPO *"
                  fullWidth={true}
                  name="type"
                  errorText={this.errorField.type}
                  value={this.state.type}
                  onChange={this.handleChange.bind(this, null, 'type')}
                >
                  <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                  <MenuItem value={"PF"} label={"PF"}  primaryText={"PF"} />
                  <MenuItem value={"PJ"} label={"PJ"}  primaryText={"PJ"} />
                </SelectField>
              </Col>                           
              <Col id="i_status"    style={{height:80}}>
                <SelectField
                  floatingLabelText="STATUS *"
                  fullWidth={true}
                  name="status"
                  errorText={this.errorField.status}
                  value={this.state.status}
                  onChange={this.handleChange.bind(this, null, 'status')}
                >
                  <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                  <MenuItem value={"ATIVO"} label={"ATIVO"}  primaryText={"ATIVO"} />
                  <MenuItem value={"INATIVO"} label={"INATIVO"}  primaryText={"INATIVO"} />
                </SelectField>
              </Col>
              <Col id="i_usersTable"    style={{height:80}}>
              <Checkbox
                  label={"Usar em Planilha?"}
                  checked={this.state.usersTable}
                  onCheck={this.confirmCheck.bind(this)}
                 // disabled={this.state.details.salesmanConfirm!=null}
              />                
              </Col>
           
               {/* 
              <Col id="i_codeS4" xs="4" sm="4" md="4" lg="4" style={{height:80}}>
                <TextField
                  floatingLabelText="BADGE"
                  fullWidth={true}
                  name="badge"
                  errorText={this.errorField.badge}
                  value={this.state.badge}
                  onChange={this.handleChange.bind(this)}
                />
              </Col>
               */}
            </Row>

            <p style={{marginBottom: 0}} className="form_p_title">VALORES DA TABELA FAMILIAR</p>     
            <Row>
            <Col id="i_value2" xs="4" sm="4" md="4" lg="4" style={{height:80}}>
            <TextField
                  floatingLabelText="Valor 2"
                  fullWidth={true}
                  name="value2"
                  >
                    <InputMask 
                      mask="99,99"
                      maskChar=" "
                      errorText={this.errorField.value2}
                      value={this.state.value2}
                      onChange={this.handleChange.bind(this)}     
                      name="value2"
               
                    />
                  </TextField>
              </Col>  
              <Col id="i_value3" xs="4" sm="4" md="4" lg="4" style={{height:80}}>
              <TextField
                  floatingLabelText="Valor 3"
                  fullWidth={true}
                  name="value3"
                  >
                    <InputMask 
                      mask="99,99"
                      maskChar=" "
                      errorText={this.errorField.value3}
                      value={this.state.value3}
                      onChange={this.handleChange.bind(this)}     
                      name="value3"
               
                    />
                  </TextField>
              </Col>  
              <Col id="i_value4" xs="4" sm="4" md="4" lg="4" style={{height:80}}>
                <TextField
                  floatingLabelText="Valor 4"
                  fullWidth={true}
                  name="value4"
                  >
                    <InputMask 
                      mask="99,99"
                      maskChar=" "
                      errorText={this.errorField.value4}
                      value={this.state.value4}
                      onChange={this.handleChange.bind(this)}     
                      name="value4"
               
                    />
                  </TextField>

              </Col>                                            
            </Row>
{/* 


                    <TextField
                      name="price"
                      fullWidth={true}
                      floatingLabelText="PREÇO"
                    >
                      <InputMask
                        name="price"
                        mask="99.99"
                        maskChar=" "
                        data-id={input.chave}
                        value={input.price}
                        onChange={this.handleChange.bind(this)}
                      />
                    </TextField>
            <p style={{marginBottom: 0}} className="form_p_title">CARÊNCIAS</p>
            <p className="form_p_title2"></p>
            {this.state.carencias.map((input, index) =>
              <Row key={input.chave} style={{backgroundColor: '#f8f8f8', paddingTop: '20px', paddingBottom: '10px', marginBottom: "20px"}}>
                <Col xs="11" sm="11" md="11" lg="11">
                  <Row>
                    <Col id="i_opcoes_cartao" xs="12" sm="12" md="4" lg="5" style={{height:80}}>
                    <TextField
                        floatingLabelText="Cobertura"
                        name="carenciaName"
                        fullWidth={true}
                        data-id={input.chave}
                        value={input.carenciaName}
                        onChange={this.handleChange.bind(this, input, 'carenciaName', '')}
                      />
                    </Col>
                    
                    <Col id="i_opcoes_cartao_dias" xs="12" sm="12" md="4" lg="4" style={{height:80}}>
                      <SelectField
                        floatingLabelText="CARÊNCIA TEMPO NO CARTÃO"
                        fullWidth={true}
                        name="carenciaCard"
                        value={input.carenciaCard}
                        onChange={this.handleChange.bind(this,  input, 'carenciaCard')}
                      >
                        <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                        {this.state.dias_carencia.map((value, _index) =>
                          <MenuItem value={value.key} key={_index} label={value.name} primaryText={value.name}/>
                        )}
                      </SelectField>
                    </Col>

                    <Col id="i_opcoes_boleto_dias" xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                      <SelectField
                        floatingLabelText="CARÊNCIA TEMPO NO BOLETO"
                        fullWidth={true}
                        name="carenciaBoleto"
                        value={input.carenciaBoleto}
                        onChange={this.handleChange.bind(this,  input, 'carenciaBoleto')}
                      >
                        <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                        {this.state.dias_carencia.map((value, _index) =>
                          <MenuItem value={value.key} key={_index} label={value.name} primaryText={value.name}/>
                        )}
                      </SelectField>
                    </Col>
                  </Row>
                </Col>
                <Col  xs="1" sm="1" md="1" lg="1" style={{textAlign:"left"}}>
                  <Button
                    onClick={() => {
                        if(index == 0)
                          this.handlerAppendCarenciaGroup();
                        else
                          this.handleDeleteCarenciaGroup(input);
                      }}
                      style={{maxWidth:"left", fontSize: "12px"}}
                    >
                      {index == 0 ?  
                        <i className="fas fa-plus">&nbsp;</i> : 
                        <i className="fas fa-minus">&nbsp;</i>}
                    </Button>
                </Col>
              </Row>  
            )}


            <p style={{marginBottom: 0}} className="form_p_title">GRUPO DE PREÇOS</p>
            <p className="form_p_title2">(Formação dos preços e promoções)</p>
            {this.state.grupos.map((input, index) =>
              <Row key={input.chave} style={{backgroundColor: '#f8f8f8', paddingTop: '20px', paddingBottom: '10px', marginBottom: "20px"}}>
                <Col xs="11" sm="11" md="11" lg="11">
                  <Row>
                  <Col id="i_Estado" xs="12" sm="12" md="2" lg="2" style={{height:80}}>
                    <SelectField
                      floatingLabelText="UF"
                      fullWidth={true}
                      name="uf"
                      value={input.uf}
                      onChange={this.handleChange.bind(this, input, 'uf')}
                    >
                      <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                      {this.state.stateList.map(item =>
                        <MenuItem key={item.Id} value={item.Id} label={item.Sigla}  primaryText={item.Sigla} />
                      )}
                    </SelectField>
                  </Col>
                  <Col id="i_city" xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                    <SelectField
                      floatingLabelText="CIDADE"
                      fullWidth={true}
                      name="city"
                      value={input.city}
                      onChange={this.handleChange.bind(this, input, 'city')}
                    >
                      <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                      {input.cityList.map(item =>
                        <MenuItem key={item.Id} value={item.Id} label={item.Nome}  primaryText={item.Nome} />
                      )}
                    </SelectField>
                  </Col>
                  <Col id="i_category" xs="12" sm="12" md="3" lg="3">
                    <SelectField
                      floatingLabelText="CATEGORIA DE PREÇO"
                      fullWidth={true}
                      name="categoryPrice"
                      value={input.categoryPrice}
                      onChange={this.handleChange.bind(this, input, "categoryPrice")}
                    >
                      <MenuItem value={"NULL"} label="Não Selecionado" primaryText="Não Selecionado"/>
                      <MenuItem value={"CARTÃO"} label="CARTÃO" primaryText="CARTÃO"/>
                      <MenuItem value={"BOLETO"} label="BOLETO" primaryText="BOLETO"/>
                    </SelectField>
                  </Col>

                  <Col id="i_preco" xs="12" sm="12" md="3" lg="2" style={{height:80}}>
                    <TextField
                      name="price"
                      fullWidth={true}
                      floatingLabelText="PREÇO"
                    >
                      <InputMask
                        name="price"
                        mask="99.99"
                        maskChar=" "
                        data-id={input.chave}
                        value={input.price}
                        onChange={this.handleChange.bind(this)}
                      />
                    </TextField>
                  </Col>
                  <Col id="i_preco_promocional" xs="12" sm="12" md="3" lg="2" style={{height:80}}>
                    <TextField
                      name="promotionPrice"
                      fullWidth={true}
                      floatingLabelText="PREÇO PROMOCIONAL"
                    >
                      <InputMask
                        name="promotionPrice"
                        mask="99.99"
                        maskChar=" "
                        data-id={input.chave}
                        value={input.promotionPrice}
                        onChange={this.handleChange.bind(this)}/>
                    </TextField>
                  </Col>

                  <Col id="i_quantidade_pessoas" xs="12" sm="12" md="3" lg="2" style={{height:80}}>
                    <TextField
                      name="quantity"
                      fullWidth={true}
                      floatingLabelText="QTD. PESSOAS"
                    >
                      <InputMask
                        name="quantity"
                        mask="9999"
                        maskChar=" "
                        data-id={input.chave}
                        value={input.quantity}
                        onChange={this.handleChange.bind(this)}
                      />
                    </TextField>
                  </Col>

                  <Col id="i_periodo_inicial" xs="12" sm="12" md="3" lg="2" style={{height:80}}>
                    <TextField
                      name="startDate"
                      fullWidth={true}
                      floatingLabelText="PERÍODO INICIAL"
                    >
                    <InputMask
                        name="startDate"
                        mask="99/99/9999"
                        maskChar=" "
                        data-id={input.chave}
                        value={input.startDate}
                        onChange={this.handleChange.bind(this)}
                      />
                    </TextField>
                  </Col>
                  <Col id="i_periodo_final" xs="12" sm="12" md="3" lg="2" style={{height:80}}>
                      <TextField
                        name="endDate"
                        fullWidth={true}
                        floatingLabelText='PERÍODO FINAL'
                      >
                        <InputMask
                          name="endDate"
                          mask="99/99/9999"
                          maskChar=" "
                          data-id={input.chave}
                          value={input.endDate}
                          onChange={this.handleChange.bind(this)}
                        />
                      </TextField>
                  </Col>
                </Row>
                </Col>
                <Col  xs="1" sm="1" md="1" lg="1" style={{textAlign:"left"}}>
                  <Button
                    onClick={() => {
                        if(index == 0)
                          this.handlerAppendPriceGroup();
                        else
                          this.handleDeletePriceGroup(input);
                      }}
                      style={{maxWidth:"left", fontSize: "12px"}}
                    >
                      {index == 0 ?  
                        <i className="fas fa-plus">&nbsp;</i> : 
                        <i className="fas fa-minus">&nbsp;</i>}
                    </Button>
                </Col>
              </Row>  
            )}
 */}
            <Row>
              <Col xs="12" sm="12" md="12" lg="12" style={{textAlign:"center"}}>
              <Button
                  onClick={() => window.location.href= urlBase.client +'panel/planlist'}
                  className="button_back_panel"
                >
                  Cancelar
                </Button>

                <Button
                  onClick={() => this.hanlderSubmit()}
                  className="button_next_panel"
                >
                  Cadastrar
                </Button>
                
              </Col>
            </Row>
          </Container>

        </Container>
        <Dialog
          modal={true}
          open={this.state.modalErrors}
          onRequestClose={this.handleErrorClose.bind(this)}
        >
          <p className="modal_title">AVISO!</p>
          <div className="modal_error_text">
            Verifique os campos com <span style={{color:"red"}}>*</span>, pois eles são obrigatórios!.
          </div>
          <div style={{ textAlign: "center" }}>                    
              <Button onClick={this.handleErrorClose.bind(this)} className="modal_button2" >FECHAR</Button>{''}                    
          </div>
        </Dialog>  
      </div>
    );

  }
}

export default BrokerRegistration;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/Brokers/BrokerRegistration.js
 **/